import { FC, useState, useEffect } from "react";
import { Anchor, AppShell, Group, Image } from "@mantine/core";
import { Logo } from "../../../../Components/Logo";
import { GooglePlayBadge } from "../../../../Components/GooglePlayBadge";
import { IOSInstallButton } from "../../../../Components/IOSInstallButton";
import { getPresentationParamsForOrigin } from "../../../../getPresentationParamsForOrigin";

function isMobileDevice(): boolean {
  if (typeof navigator === "undefined") return false;
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 1);
  const isAndroid = /android/i.test(navigator.userAgent);
  return isIOS || isAndroid;
}

function isInstalledAsPWA(): boolean {
  if (typeof window === "undefined") return false;
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  const isIOSStandalone =
    (navigator as { standalone?: boolean }).standalone === true;
  return isStandalone || isIOSStandalone;
}

export const AppHeader: FC = () => {
  const presentator = getPresentationParamsForOrigin().ads?.presentation;
  const [showSponsor, setShowSponsor] = useState(false);

  useEffect(() => {
    // Show sponsor when no app buttons are visible (desktop or PWA installed)
    const mobile = isMobileDevice();
    const installed = isInstalledAsPWA();
    setShowSponsor(!mobile || installed);
  }, []);

  return (
    <AppShell.Header
      style={{
        padding: "var(--mantine-spacing-md)",
        paddingTop:
          "calc(var(--mantine-spacing-md) + env(safe-area-inset-top, 0px))",
        paddingInlineStart:
          "calc(var(--mantine-spacing-md) + env(safe-area-inset-left, 0px))",
        paddingInlineEnd:
          "calc(var(--mantine-spacing-md) + env(safe-area-inset-right, 0px))",
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
      }}
    >
      <Group h="100%" justify="space-between">
        <Logo to="/" />

        <Group gap="md">
          <GooglePlayBadge height={40} />
          <IOSInstallButton height={40} />

          {presentator && showSponsor && (
            <Anchor
              href={presentator.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                alt={presentator.name}
                src={presentator.logoUrl}
                h={32}
                w="auto"
                fit="contain"
              />
            </Anchor>
          )}
        </Group>
      </Group>
    </AppShell.Header>
  );
};
